export default function SecurityCollapse(props, ref) {
    return (
        <div style={{height:1}}/>
    );
}
